import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch, onMounted, getCurrentInstance } from 'vue';
import { RailResponse } from '@/types/cms';
import { Language } from '@/enums/language';
import { useStore } from '@/composables/useStore';
import { useRailNavigation } from '@/composables/useRailNavigation';
import { useCMSItemNavigation } from '@/composables/useCMSItemNavigation';
import TG4Image from '@/components/TG4Image.vue';
import TG4PlayIcon from '@/components/TG4PlayIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SingleContentRail',
  props: {
    rail: null,
    railIndex: null,
    railDidNavigateDown: null
  },
  setup(__props: any) {

const props = __props as {
  rail: RailResponse;
  railIndex: number;
  railDidNavigateDown?: (railIndex: number) => void;
};





const { itemId, handleUp, handleDown, handleLeftFallback } = useRailNavigation(props);
const { openItem } = useCMSItemNavigation();

const { useGetter } = useStore();
const currentLanguage = useGetter<string>('currentLanguage');

const localised = (en: string | null, ga: string | null) => {
  const value = currentLanguage.value === Language.Irish ? ga : en;
  return value ?? en ?? '';
};

const title = computed(() => localised(props.rail.titleEn, props.rail.titleGa));
const subtitle = computed(() => localised(props.rail.subtitleEn, props.rail.subtitleGa));

const item = computed(() => props.rail.items[0] ?? null);

const image = computed(() => {
  const value = item.value;
  if (!value) return null;
  if (value.type === 'SERIES') return value.series.mainImage;
  if (value.type === 'VIDEO') return value.video.image;
  return null;
});

const textStyle = computed(() => ({
  color: props.rail.textColor ?? undefined,
}));

const handlePress = () => {
  if (item.value) openItem(item.value);
};

const rootRef = ref<HTMLElement | null>(null);
const lazyLoad = getCurrentInstance()?.proxy?.$lazyLoad;

const scanForLazyImages = () => {
  setTimeout(() => {
    if (rootRef.value) lazyLoad?.(rootRef.value);
  }, 200);
};

onMounted(scanForLazyImages);


return { __sfc: true,props, itemId, handleUp, handleDown, handleLeftFallback, openItem, useGetter, currentLanguage, localised, title, subtitle, item, image, textStyle, handlePress, rootRef, lazyLoad, scanForLazyImages, TG4Image, TG4PlayIcon }
}

})